import { io } from "socket.io-client";
import { getToken } from "./localStorageMethods";

const SOCKET_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5005';

// Export a single socket instance for use throughout the app
export const socket = io(SOCKET_URL, {
  autoConnect: false,
  transports: ["websocket"],
});

// Helper to connect with JWT auth so backend can authenticate and track this socket
export function connectSocketWithUserId(userId) {
  const token = getToken();
  if (token) {
    socket.auth = { token };
  }
  if (!socket.connected) {
    socket.connect();
  }
}

// Helper to send regulatory compliance registration event
export function sendRegulatoryCompliance(data) {
  socket.emit("regulatory-compliance-registered", data);
}

// Send a custom notification to a specific user
export function sendNotificationToUser({ to, type }) {
  if (!to) return;

  socket.emit("compliance-status-update", {
    to,
    type,
  });
}
